import { createAsyncThunk } from "@reduxjs/toolkit"
import { coreActions } from "../slices/core.slice"

export const setApplicationMessages = createAsyncThunk(
  "core/setApplicationMessages",
  async (_arg: any, { dispatch }) => {
    const JSONURL = "/assets/config/resources.en-us.json"
    try {
      const res = await fetch(JSONURL, { method: "GET" })
      // BUG #9: Add error handling for failed fetch/parse
      if (!res.ok) {
        console.error(`Failed to fetch messages: ${res.status} ${res.statusText}`)
        return
      }
      const messages = await res.json()
      dispatch(coreActions.setApplicationMessages(messages))
    } catch (error) {
      console.error("[setApplicationMessages] Failed to load messages:", error)
      // Silently fail - messages aren't critical to app functionality
    }
  }
)
